<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col></b-col>
            <b-col class="text-center title">會員管理 / 會員查詢</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                <b-card class="bg-default-card">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-4 box-shadow" header="Form Elements">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group p-10 ">
                                            <div class="row">
                                                <label class="control-label col-md-2" for="text">姓名：
                                                </label>
                                                <div class="col-md-8">
                                                    <input type="text" class="form-control" id="text" v-model="search.name" placeholder="請輸入姓名">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group p-10 ">
                                            <div class="row">
                                                <label class="control-label col-md-3" for="text">電話：
                                                </label>
                                                <div class="col-md-6">
                                                    <input type="phone" class="form-control" id="text" placeholder="請輸入電話" v-model="search.mobile">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group p-10 row">
                                            <div class="col-2 mb-2">狀態：</div>
                                            <div class="col-lg-3 col-md-3">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.status" type="radio" name="x" value="0"> 全部
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-3">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.status" type="radio" name="x" value="1"> 正常
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-3">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.status" type="radio" name="x" value="2"> 黑名單
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group p-10">
                                            <div class="row">
                                                <label class="col-md-3 control-label" for="example-select">會員等級：</label>
                                                <div class="col-md-6">
                                                    <select id="example-select" name="example-select" class="form-control" size="1" v-model="search.level">
                                                        <option value="0">
                                                            全部
                                                        </option>
                                                        <option value="20">正式會員</option>
                                                        <option value="10">基本會員</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-9">
                                        <div class="form-group p-10 row">
                                            <div class="col-2 mb-2">性別：</div>
                                            <div class="col-lg-2 col-md-2">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.gender" type="radio" name="x1" value="0"> 全部
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.gender" type="radio" name="x1" value="male"> 男
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.gender" type="radio" name="x1" value="female"> 女
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2">
                                                <div class="custom-controls-stacked">
                                                    <input class="radiobox-boom" v-model="search.gender" type="radio" name="x1" value="private"> 不公開
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group p-10 form-actions">
                                            <div class="col-md-offset-4 col-md-12">
                                                <button type="button" class="btn text-white btn-warning" @click="getmemberlist(1)">查詢</button>&nbsp;
                                                <button type="button" class="btn text-white btn-warning" @click="form_reset()">
                                                    重設
                                                </button>&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-collapse>
            <!-- First Basic Table Ends Here-->
            <!-- Second Data Table Starts Here-->
            <b-card class="bg-default-card">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="p-4 box-shadow" header="Form Elements">
                            <div class="table-responsive">
                                <table id="mytable" class="table table-bordred table-striped">
                                    <thead>
                                        <tr>
                                            <th>姓名</th>
                                            <th>會員等級</th>
                                            <th>狀態</th>
                                            <th>性別</th>
                                            <th>電話</th>
                                            <th>功能</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="x in member_list" :key="x.ID">
                                            <td>{{ x.Name }}</td>
                                            <td>{{ x.GradeText }}</td>
                                            <td>{{ x.Status == 1 ? '正常':'黑名單' }}</td>
                                            <td>{{ x.Gender == 'male' ? '男': x.Gender == 'female' ? '女': x.Gender == 'private' ? '不公開' : '' }}</td>
                                            <td>{{ x.Mobile }}</td>
                                            <td>
                                                <router-link tag="a" :to="{ name: 'member_info_edit', params: { memberid: x.ID, membername: x.Name, search:search } }" class="btn btn-outline-primary btn_width btn_rounded mt-3">會員資料</router-link>
                                                <router-link tag="a" :to="{ name: 'member_info_bonus_history', params: { memberid: x.ID, membername: x.Name, search:search } }" class="btn btn-outline-danger btn_width btn_rounded mt-3">累點紀錄</router-link>
                                                <router-link tag="a" :to="{ name: 'member_info_exchange_history', params: { memberid: x.ID, membername: x.Name, search:search } }" class="btn btn-outline-success btn_width btn_rounded mt-3">點數兌換票券紀錄</router-link>
                                                <router-link tag="a" :to="{ name: 'member_info_coupon_history', params: { memberid: x.ID, membername: x.Name, search:search } }" class="btn btn-outline-secondary btn_width btn_rounded mt-3">電子券使用紀錄</router-link>
                                                <router-link tag="a" :to="{ name: 'information_tickethistory_list', params: { memberid: x.ID, membername: x.Name, memberphone: x.Mobile, membergrade: x.GradeText } }" class="btn btn-outline-info btn_width btn_rounded mt-3">電子票券匣</router-link>
                                                <router-link tag="a" :to="{ name: 'member_info_storepay_history', params: { memberid: x.ID, membername: x.Name, search:search } }" class="btn btn-outline-warning btn_width btn_rounded mt-3">臨櫃付款未取紀錄</router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row" style="padding: 0 1rem">
                                <b-pagination size="md" :total-rows="totalrows" v-model="search.currentPage" :per-page="rows" @change="getmemberlist"></b-pagination>
                                <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalrows}}筆</label>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import VueForm from 'vue-form'
import options from 'validations'
import { mapGetters } from 'vuex'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
export default {
  name: 'Member_Offer',
  data () {
    return {
      rows: 20,
      totalrows: 0,
      startRowNum: 0,
      endRowNum: 0,
      search: {
        name: '',
        mobile: '',
        status: 0,
        gender: '0',
        level: 0,
        currentPage: 1
      },
      model: {
        username: '會員一',
        email: 'abc123@ptc-net.com.tw',
        mobile: '0912345678',
        gender: 1,
        dob: '2018-08-02',
        password: '',
        repeatPassword: '',
        address: ' ',
        city: '',
        country: 1,
        pin: '',
        terms: false,
        Referrer: '推薦人一',
        Point: 10,
        Status: 0
      },
      member_list: []
    }
  },
  computed: mapGetters({
    // 取得 loading state
    loading: 'getLoading'
  }),
  methods: {
    form_reset () {
      this.search = {
        name: '',
        mobile: '',
        status: 0,
        gender: '0',
        level: 0
      }
      this.getmemberlist(1)
    },
    getmemberlist: function (currentPage) {
      this.$parent.Loading = true

      return axios.post(API_URL + '/web/memberlist/v1', {
        ToPage: currentPage,
        PerPage: this.rows,
        Rows: this.rows,
        MemberName: this.search.name,
        Mobile: this.search.mobile,
        Status: parseInt(this.search.status),
        Level: parseInt(this.search.level),
        Gender: this.search.gender
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.member_list = response.data.memberlist
            this.search.currentPage = response.data.pageNumber
            this.totalrows = (response.data.count === undefined) ? 0 : response.data.count
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.rows * (this.search.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.rows > response.data.count) ? response.data.count : (this.search.currentPage * this.rows) >= response.data.count ? response.data.count : this.search.currentPage * this.rows
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error('會員查詢失敗')
          this.$parent.Loading = false
        })
    },
  },
  mounted: function () {

  },
  destroyed: function () {

  },
  created () {
    this.FunctionPermission = getFunctionPermission('F07') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    if (this.$route.params.search !== undefined) {
      this.search = this.$route.params.search
    }
    console.log(this.search)
    this.getmemberlist(this.search.currentPage)
  }
}
</script>
<style scoped>
    .align-left{
        float: left;
    }
    .align-right{
        float: right;
    }
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/info/List.vue